import React from 'react'
import CieModal from '../components/layout/CieModal/CieModal';
import CieTabs from '../components/elements/CieTabs';


import BtBottom from "../assets/img/icons/bt_arrow_bottom_black.svg";
import NousConnaitre4 from '../assets/img/icons/nous_connaitre_4.svg';
import Gouvernance from '../assets/img/gouvernance.png';
import Organigramme from '../assets/img/organigramme.svg';


export default function NousConnaitre() {
    let content = `
					<div class='columns is-multiline pb-6 '>
            <div class='column is-12 is-offset-2-widescreen is-4-widescreen'>
              <div class="is-flex is-align-items-center">
                <img class="responsive-image img_nb" style="max-width: 155px" src=${NousConnaitre4} />
                <h3 class='mb-0'>axes<br/>orientent<br/>les actions<br/>de l'entreprise</h3>
              </div>
              <div class='modalNousConnaitre__list'>
                <h4>La satisfaction<span>des locataires actuels et futurs</span></h4>
                <h4>L'épanouissement<span>des collaborateurs</span></h4>
                <h4>Le souci<span>de la performance</span></h4>
                <h4>La réponse, à son niveau,<span>aux défis environnementaux</span></h4>
              </div>
              <a class="bt_next_modal cursor_pointer" href="#nousConnaitreTabs"><img class='responsive-image'  src='${ BtBottom }' /></a>
            </div>`;

    content += `<div class='column is-12 is-offset-1-widescreen is-4-widescreen'>
              <p class='text_chapo'>Elogie-Siemp, 3<sup>e</sup> bailleur social de la Ville de Paris, gère un patrimoine de près de 29 000 logements à Paris et en banlieue, ce qui représente environ 70 000 locataires.</p><p>Forte de plus de 500 collaborateurs, Elogie-Siemp ambitionne de répondre aux objectifs de la Ville en matière de production de logements sociaux, d’amélioration de la qualité du service rendu aux locataires et de lutte contre le dérèglement climatique. Le choix d'une gouvernance resserrée et collective, ainsi que le renforcement du maillage territorial et de la présence des gardiennes et gardiens auprès des locataires, participent de l'atteinte de ces objectifs.</p>
              <p>Elogie-Siemp gère son patrimoine en veillant à la valorisation du patrimoine en s’assurant de l’entretien, de la maintenance et de la mise à niveau des équipements comme du bâti tout en s’engageant pour un futur neutre en carbone.</p>
              <p>Engagée depuis plusieurs années dans une démarche de Responsabilité Sociétale de l’Entreprise (RSE)*, Elogie-Siemp conforte ainsi ses valeurs et son goût de l’innovation architecturale, environnementale, sociale et culturelle. Au travers de cette démarche transverse et participative, associant de nombreux collaborateurs, elle ambitionne de mettre en cohérence ses actions et d’en mesurer les conséquences. Elle renforce ainsi sa contribution positive à la construction d’une société plus responsable, plus durable et plus inclusive.</p>
              <p>* Pour mettre en place une mesure de sa performance, elle a choisi le référentiel EURHO-GR®, développé par l’association Delphis réunissant de nombreux bailleurs sociaux.</p>

            </div>
          </div>
				`;


    return ( < CieModal showNext id = "modalNousConnaitre"

        open = "<a href='#' class='nav-link'>Nous connaître</a>"
        content = { content }
        content_add = { <CieTabs id = "nousConnaitreTabs"
            currentActiveTabs = { 0 }
            titles = {
                ['Gouvernance', 'Organigramme']
            }
            datas = {
                [ <img src = { Gouvernance }
                    class = "responsive-image" /> , <img src = { Organigramme }
                    class = "responsive-image organigramme" />
                ]
            }
            />} />
        )
    }
